<template>
    <div class="list-section-wrapper" :data-page-number="currentPage" id="listSectionWrapper" :class="{'isClub': isClub}">
        <h1 v-if="resultsTitle && !isClub" class="results-title" :class="{ 'text-center' : noSearchBarResults }" v-html="resultsTitle"></h1>
        <div v-if="noSearchBarResults" class="w-100 d-flex justify-content-center">
            <button class="mt-2 catalog-button" @click="$emit('clearSearchBar')"> {{ kStrings.kBACK_TO_WERE_I_WAS }} </button>
        </div>
        <div v-if="productsList" class="row list-container" :data-mub="mubBlock.normal">
            <block :struct="productsList" />
        </div>

        <div v-if="(pageIndexList && listPaginationMode == 'pager')" class="w-100 d-flex justify-content-center pagination-wrapper">
            <ul>
                <li v-for="(item, index) in pageIndexList" :key="'page-' + index"
                    class="pagination-button" 
                    :class="{ 'selected' : item.type == 'selected', 'disabled' : item.type == 'dots'}" 
                    :data-type="item.type"
                    @click="paginationControl(item.url, item.type)"
                >
                    <i v-if="item.type == 'prev'" class="ecom-chevron-left"/>
                    <i v-if="item.type == 'next'" class="ecom-chevron-right"/>
                    {{ (item.type != 'prev' && item.type != 'next') ? item.description : '' }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {isEmpty} from 'lodash-es';
import {store} from '@/store/catalog';
import apiCatalog from '@/api/catalog';
import smoothscroll from 'smoothscroll-polyfill';

import Block from '@/components/Blocks/Block/Desktop.vue';
import { BlockStruct } from '@/models/Blocks/block-struct';

//import LoadPictureSquare from '@/components/LoadPictureSquare';

export default {
    store,
    name: 'List',
    components: {
        Block,
    },
    props: {
        products: {
            type: Array,
            default: null
        },
        listTitle: {
            type: String,
            default: null
        },
        isClub:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            productsList: null,
            clickList: {}, 
        }
    },
    computed: {
        isLoading() {
            return this.$store.getters.isLoading;
        },
        searchListText() {
            return this.$store.getters.searchListText;
        },
        mubBlock() {
            return this.$store.getters.extras.mubBlock;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        noSearchBarResults() {
            return isEmpty(this.products);
        },
        resultsTitle() { 
            if(this.noSearchBarResults) { 
                return this.kStrings.kNO_RESULTS_CRITERIA;
            }
            
            return !this.noSearchBarResults ? this.listTitle : this.kStrings.kEVT_RESULTS_SEARCH_EMPTY + ': ' + '"' + this.searchListText + '"';
        },
        totalProducts() {
            return this.$store.getters.totalProducts;  
        },
        pagination() {
            const data = this.$store.getters.pagination;
            return !isEmpty(data) ? data : null;
        },
        currentPage() {
            return this.pagination ? this.pagination.currentPage : 1
        },
        pageIndexList() {
            return this.pagination && Object.keys(this.pagination.pageIndexList).length > 1 ? this.pagination.pageIndexList : null;
        },
        autoLoad() {
            if(this.isLoading || !this.pagination) {
                return false;
            }
            return this.currentPage <= 3 && (this.currentPage < this.pagination.totalPages);
        },
        listPaginationMode() {
            if (!this.pagination) {
                return null;
            }
            return 'pager';
        }
    },
    watch:{
        products: {
            handler(list) {
                this.setProductList(list);
            },
            immediate: true
        }
    },
    mounted() {
        smoothscroll.polyfill();
        const urlLocation = new URL(window.location.href);
        history.replaceState({quicksearch: "1", no_action: "1", refresh: true}, "", urlLocation);
    },
    methods: {
        setProductList(list){
            let struct = null;
            if(this.isClub){
                struct = [[['s'],['s'],['s'],['s'],['s'],['s']]];
            }else{
                struct = [[['s'],['s'],['s'],['s']]];
            }
            let temp = new BlockStruct(struct,list, true);
            this.productsList = temp.getStruct();
        },
        filterSearch(options, query) {
            if (!isEmpty(options)) {
                const asArray = Object.entries(options);
                const filtered = asArray.filter(([key, value]) => value.name.toLowerCase().includes(query.toLowerCase()));
                // Convert the key/value array back to an object:
                return Object.fromEntries(filtered);
            }
        },
        mouseEvent(prod, hover){
            prod.opacity = hover ? 1 : 0;
        },
        async loadMore() { // for manual / lady loading pagination
            let pageUrls = this.pagination.pageUrls;
            let nextPageIndex = this.pagination.currentPage + 1;
            let nextPage = pageUrls.hasOwnProperty(nextPageIndex) ? pageUrls[nextPageIndex] : null;
            //console.log('next page: ', nextPage);
            if(nextPage) {
                this.$store.dispatch('setLoading', true);
                const response = await apiCatalog.backendRequest(nextPage.url, 'page-' + nextPageIndex);
                if(response.data.hasOwnProperty('catalogData')) {
                    this.$emit('updateCatalog', response.data.catalogData);
                }
                this.$store.dispatch('setLoading', false);
            }
        },
        async paginationControl(url, type = 'index') { // for pagination button bottom navigation
            if(url && type != 'dots') {
                this.$store.dispatch('setLoading', true);
                const response = await apiCatalog.backendRequest(url, 'list-pagination-' + type, {}, {quicksearch: "1", no_action: "1", refresh: true});
                
                if(response.data.hasOwnProperty('catalogData')) {
                    // scroll to top
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    // load new products
                    setTimeout(() => {
                        this.$emit('updateCatalog', response.data.catalogData);
                    }, 100);

                }
                this.$store.dispatch('setLoading', false);
            }
        },
        pageAutoLoad() {
            if (this.autoLoad) {
                this.loadMore();
            }
        },
        onProductClick(event){
            if(event.ctrlKey || event.metaKey){
                // using CTRL + CLICK or CMD + CLICK -> allow
                return ;
            }
            const key = 'idx-' + event.target.getAttribute('data-plc-pos');
            if(this.clickList.hasOwnProperty(key)){
                event.preventDefault();
            }
            else{
                this.clickList[key] = true;
            }
        }
    }
};
</script>
<style lang="scss">
@import "./Styles/index.scss";
@import "././Styles/catalog/index.scss";
.list-section-wrapper .prz-blk .prz-blk-product-item .prz-mob-grd-content .prz-blk-product-names span{
    opacity: 1;
    visibility: visible;
}
</style>
